import { ScheduleRowEntity } from './schedule-row-entity';
import { ScheduleFieldEntity } from './schedule-field-entity';

export class ScheduleEntity {

    public static fromDto(dto: any): ScheduleEntity {
        if (!dto) {
            return new ScheduleEntity();
        }
        const entity = new ScheduleEntity();
        entity.id = dto.id;
        entity.eventId = dto.eventId;
        entity.groupIds = dto.groupIds ?? [];
        entity.code = dto.code;
        entity.startDayOffset = dto.startDayOffset;
        entity.sortOrder = dto.sortOrder ?? 0;
        entity.name = dto.name;
        entity.concurrency = dto.concurrency;
        entity.games = ScheduleRowEntity.fromDtoArray(dto.games);
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): ScheduleEntity[] {
        const entities: ScheduleEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = ScheduleEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: ScheduleEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }
    public id: string = null;
    public eventId: string = null;
    public groupIds: string[] = [];
    public code: string = null;
    public startDayOffset: number = 0;
    public sortOrder: number = 0;
    public name: string = null;
    public concurrency: string = null;
    public games: ScheduleRowEntity[] = [];
    public fields: ScheduleFieldEntity[] = [];

    public toDto(): any {
        return {
            id: this.id,
            // eventId: this.eventId,
            groupIds: this.groupIds,
            // code: this.code,
            startDayOffset: this.startDayOffset,
            sortOrder: this.sortOrder,
            name: this.name,
            concurrency: this.concurrency
            // games:  ScheduleRowEntity.toDtoArray(this.games)
        };
    }
}
